import WidgetMyAccountLinks from './WidgetMyAccountLinks'

export default {
    'widget-my-account-links': WidgetMyAccountLinks
}
